import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Logo = ({ p }) => (
  <span className="inline-flex items-center gap-3 px-8 h-16 opacity-90 hover:opacity-100 transition-opacity duration-300">
    {p.logo
      ? <img src={p.logo} alt={p.name} data-testid="partner-strip-logo-img" className="max-h-12 max-w-[150px] object-contain mix-blend-multiply dark:mix-blend-normal dark:[filter:invert(1)_hue-rotate(180deg)_saturate(1.2)] transition-[filter] duration-300" loading="lazy" />
      : <>
        <span className="grid place-items-center w-9 h-9 rounded-lg bg-gradient-to-br from-[hsl(var(--brand))] to-[#1e3a5f] text-white font-serif text-[18px]">{p.name.charAt(0)}</span>
        <span className="text-[15px] font-semibold tracking-wide text-neutral-700 dark:text-neutral-200 whitespace-nowrap">{p.name}</span>
      </>}
  </span>
);

const PartnerLogoStrip = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/partners/strip`).then(({ data }) => setItems(data || [])).catch(() => {});
  }, []);
  if (!items.length) return null;
  const reps = Math.max(2, Math.ceil(8 / items.length));
  const row = Array.from({ length: reps }).flatMap(() => items);

  return (
    <section data-testid="partner-logo-strip" className="max-w-7xl mx-auto px-6 pt-14">
      <div className="flex items-end justify-between gap-4 mb-5">
        <div>
          <div className="text-[11px] tracking-[0.3em] uppercase text-brand font-semibold">Our network</div>
          <h2 data-testid="partner-strip-heading" className="mt-1 font-serif text-[28px] sm:text-[34px] leading-tight text-neutral-900 dark:text-neutral-100">Trusted Partners</h2>
        </div>
        <Link to="/partners" data-testid="partner-strip-view-all" className="group inline-flex items-center gap-1 text-[12.5px] text-brand font-medium whitespace-nowrap">
          <span className="hidden sm:inline">Meet our partners</span><span className="sm:hidden">View all</span> <ArrowRight size={13} className="transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
      <Link to="/partners" aria-label="View our partners" data-testid="partner-strip-track"
        className="relative block overflow-hidden rounded-2xl border border-neutral-200 dark:border-neutral-800 bg-white/70 dark:bg-[#141416]/70 backdrop-blur [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div className="flex w-max items-center animate-marquee hover:[animation-play-state:paused] [animation-duration:45s]">
          {[0, 1].map(k => (
            <div key={k} className="flex items-center" aria-hidden={k === 1}>
              {row.map((p, i) => <Logo key={`${k}-${i}`} p={p} />)}
            </div>
          ))}
        </div>
      </Link>
    </section>
  );
};

export default PartnerLogoStrip;
